import React from "react";
import { FaRegCopyright, FaHeart } from "react-icons/fa";
const Footer = () => {
  return (
    <footer className="absolute bottom-0 w-full bg-transparent bg-prColor border-t border-t-dark text-dark font-['Poppins']">
      <div className="container flex justify-between flex-wrap py-3 sm:py-6">
        <div className="flex items-center gap-2 text-sm sm:text-base">
          <FaRegCopyright className="" /> {new Date().getFullYear()}{" "}
          <span className="text-light">Portfolio</span>
          Made with <FaHeart className="text-light" />
        </div>

        <div className="logo footer">MNK DEV</div>
      </div>
    </footer>
  );
};

export default Footer;
